'use client'
import { useAddToCart } from '@/features/cart/hooks/use-add-to-cart'
import { useCartStore } from '@/store'
import { Button, CssBaselineProps } from '@mui/material'
import { useTranslations } from 'next-intl'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { useRouter } from 'next/navigation'
import { scrollBodyShow } from '@/utils/copy-content'
interface AddToCartProps {
  data?: Product
  productSelected: {
    product: IVariantsProduct | { product: Product | null } | undefined
    options: Record<string, string> | null
    parent: Product | null
  }[]
  customRender?: React.ReactNode
  quantity?: number
  disabled?: boolean
  dataWishlist?: IWishlistItem
  customAddToCartBtn?: Function
  setLocalLoading?: (value: boolean) => void
  children?: React.ReactNode
  title?: string
  variant?: 'contained' | 'text' | 'outlined'
  isBuyNow?: boolean
  isSmall?: boolean
}

export const AddToCartButton = ({
  data,
  productSelected,
  customRender,
  quantity = 1,
  disabled,
  customAddToCartBtn,
  setLocalLoading,
  children,
  title = 'THÊM VÀO GIỎ HÀNG',
  variant = 'contained',
  isBuyNow = false,
  isSmall = false,
}: AddToCartProps) => {
  const { addToCart, setShowCartMini, setIsAutoCloseMiniCart } = useCartStore()
  const [isLoading, setIsLoading] = useState(false)
  const router = useRouter()
  const t = useTranslations('Product')
  const {} = useAddToCart()
  const handleAddToCart = async () => {
    if (disabled) {
      return handleDisable()
    }
    setLocalLoading && setLocalLoading(true)
    if (customAddToCartBtn) {
      return customAddToCartBtn(setLocalLoading)
    }
    setIsLoading(true)
    const isEmpty = require('lodash/isEmpty')
    const omitBy = require('lodash/omitBy')
    const item = productSelected?.map((product) => {
      const isSimpleProduct = product?.product?.product?.__typename === 'SimpleProduct'
      const cartItem: ICartItem = {
        sku: isSimpleProduct ? product?.parent?.sku || '' : product?.product?.product?.sku || '',
        quantity: quantity,
      }
      const validOptions = omitBy(product?.options, isEmpty)
      if (!isEmpty(validOptions)) {
        cartItem.selected_options = Object.values(validOptions) as string[]
      }

      return cartItem
    })

    try {
      await addToCart(item, false)
      // toast.success(t('added-item'), {
      //   autoClose: 3000,
      //   closeButton: true,
      // })
      if (isBuyNow) {
        router.push('/cart')
        scrollBodyShow()
      }
      if (!isBuyNow) {
        setShowCartMini(true)
        setIsAutoCloseMiniCart(true)
      }
    } catch (err: any) {
      console.error('Error adding to cart:', err)
      // toast.error(err?.message || t('error-added-item'), {
      //   autoClose: 3000,
      //   closeButton: true,
      // })
    } finally {
      setIsLoading?.(false)
    }

    return
  }

  const handleDisable = () => {
    setLocalLoading && setLocalLoading(false)
    setIsLoading(false)
    toast.info(t('OUT_OF_STOCK'))
  }

  if (customRender || children)
    return (
      <div onClick={!disabled || data?.stock_status != 'IN_STOCK' ? handleAddToCart : handleDisable}>
        {customRender || children}
      </div>
    )
  return (
    <Button
      variant={variant}
      fullWidth
      onClick={handleAddToCart}
      loading={isLoading}
      disabled={disabled}
      sx={{
        fontWeight: 600,
        borderRadius: '999px',
        fontSize: { xs: '0.875rem', sm: isSmall ? '0.875rem' : '1rem' },
        p: { xs: '8px', sm: '12px' },
      }}
    >
      {title}
    </Button>
  )
}
